import * as React from 'react'
import { Limit } from '../../../components'
import { Block } from 'baseui/block';
import { Input } from "baseui/input";
import { LabelLarge } from 'baseui/typography';
import { FormControl } from 'baseui/form-control';
import { IHeatingOutlet_Optimizer } from './types'
import { SensorRangeConfig } from '../../../components/SensorRangeConfig'
// api
import { useSetObjectValue } from '../../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';
import { Checkbox, STYLE_TYPE } from 'baseui/checkbox';

export const ConfigurationPanel = (props: IHeatingOutlet_Optimizer) => {

    const [baseTemperature, setBaseTemperature, setBaseTemperatureResult] = useSetObjectValue(props.id, props.resourceGroupId, "baseTemperature", props.baseTemperature ?? 0);
    const onBaseTemperatureChanged = (e: any) => setBaseTemperature(e.target.value);

    const [factor, setFactor, setFactorResult] = useSetObjectValue(props.id, props.resourceGroupId, "factor", props.factor ?? 0);
    const onFactorChanged = (e: any) => setFactor(e.target.value);

    const [maxRTCorrection, setMaxRTCorrection, setMaxRTCorrectionResult] = useSetObjectValue(props.id, props.resourceGroupId, "maxRTCorrection", props.maxRTCorrection ?? 0);
    const onMaxRTCorrectionChanged = (e: any) => setMaxRTCorrection(e.target.value);

    const [maxOffsetRT, setMaxOffsetRT, setMaxOffsetRTResult] = useSetObjectValue(props.id, props.resourceGroupId, "maxOffsetRT", props.maxOffsetRT ?? 0);
    const onMaxOffsetRTChanged = (e: any) => setMaxOffsetRT(e.target.value);


    const [activateRTCorection, setActivateRTCorection] = useSetObjectValue(props.id, props.resourceGroupId, "activateRTCorection", props.activateRTCorection);
    const onActivateRTCorectionChanged = (e: any) => {
        if (e)
            setActivateRTCorection(true);
        else
            setActivateRTCorection(false);
    }

    const [enableForecast, setEnableForecast] = useSetObjectValue(props.id, props.resourceGroupId, "enableForecast", props.enableForecast);
    const onenableForecastChanged = (e: any) => {
        if (e)
            setEnableForecast(true);
        else
            setEnableForecast(false);
    }

    const [factorForecast, setFactorForecast, setFactorForecastResult] = useSetObjectValue(props.id, props.resourceGroupId, "factorForecast", props.factorForecast ?? 0);
    const onFactorForecastChanged = (e: any) => setFactorForecast(e.target.value);

    const [correctionTempForecast, setcorrectionTempForecast, setcorrectionTempForecastResult] = useSetObjectValue(props.id, props.resourceGroupId, "correctionTempForecast", props.correctionTempForecast ?? 0);
    const oncorrectionTempForecastChanged = (e: any) => setcorrectionTempForecast(e.target.value);

    return (
        <Block gridRowGap='20px' minWidth={'200px'} minHeight={'200px'} justifyContent='center' display='flex' flexDirection='column' flexWrap>
            <FormControl
                label={<FormattedMessage id="IHeatingOutlet_Optimizer.BaseTemperature" defaultMessage="Base temperature" />}
                caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextBaseTemperature" defaultMessage="The basic temperature of the heating curve is set here." />}
            >
                <Input
                    value={baseTemperature}
                    onChange={onBaseTemperatureChanged}
                    placeholder="[°C]"
                    endEnhancer={"°C"}
                    disabled={setBaseTemperatureResult.isLoading}
                    error={setBaseTemperatureResult.isError}
                />
            </FormControl>
            <FormControl
                label={<FormattedMessage id="IHeatingOutlet_Optimizer.Factor" defaultMessage="Factor" />}
                caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextFactor" defaultMessage="The factor for shifting the heating curve is set here." />}
            >
                <Input
                    value={factor}
                    onChange={onFactorChanged}
                    placeholder="[°C]"
                    endEnhancer={"°C"}
                    disabled={setFactorResult.isLoading}
                    error={setFactorResult.isError}
                />
            </FormControl>
            <FormControl
                    caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextenableForecast" defaultMessage="To activate the WeatherForecast." />}>
                    <Checkbox
                        checked={enableForecast}
                        checkmarkType={STYLE_TYPE.toggle_round}
                        onChange={(e: any) => { onenableForecastChanged(e.target.checked) }}
                        disabled={false}>
                        {<FormattedMessage id="IHeatingOutlet_Optimizer.enableForecast" defaultMessage="Activate the WeatherForecast" />}
                    </Checkbox>
            </FormControl>
            {enableForecast &&
                <FormControl
                    label={<FormattedMessage id="IHeatingOutlet_Optimizer.factorForecast" defaultMessage="WeatherForecast values" />}
                    caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextfactorForecast" defaultMessage="Values from the WeatherForecast" />}
                >
                    <Input
                        value={factorForecast}
                        onChange={onFactorForecastChanged}
                        placeholder="[°C]"
                        endEnhancer={"°C"}
                        disabled={setFactorForecastResult.isLoading}
                        error={setFactorForecastResult.isError}
                    />
                </FormControl>

            }
            <FormControl
                caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextActivateRTCorection" defaultMessage="To activate the room temperature correction." />}>
                <Checkbox
                    checked={activateRTCorection}
                    checkmarkType={STYLE_TYPE.toggle_round}
                    onChange={(e: any) => { onActivateRTCorectionChanged(e.target.checked) }}
                    disabled={false}>
                    {<FormattedMessage id="IHeatingOutlet_Optimizer.ActivateRTCorection" defaultMessage="Activate roomtemperaure correction" />}
                </Checkbox>
            </FormControl>
            {activateRTCorection &&
                <FormControl
                    label={<FormattedMessage id="IHeatingOutlet_Optimizer.MaxOffsetRT" defaultMessage="Maximum offset" />}
                    caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextMaxOffsetRT" defaultMessage="Maximum room temperature deviation for flow correction." />}
                >
                    <Input
                        value={maxOffsetRT}
                        onChange={onMaxOffsetRTChanged}
                        placeholder="[°C]"
                        endEnhancer={"°C"}
                        disabled={setMaxOffsetRTResult.isLoading}
                        error={setMaxOffsetRTResult.isError}
                    />
                </FormControl>
            }
            {activateRTCorection &&
                <FormControl
                    label={<FormattedMessage id="IHeatingOutlet_Optimizer.MaxRTCorrection" defaultMessage="Maximum correction" />}
                    caption={<FormattedMessage id="IHeatingOutlet_Optimizer.TextMaxRTCorrection" defaultMessage="Maximum correction of the flow temperature based on the current room temperature." />}
                >
                    <Input
                        value={maxRTCorrection}
                        onChange={onMaxRTCorrectionChanged}
                        placeholder="[°C]"
                        endEnhancer={"°C"}
                        disabled={setMaxRTCorrectionResult.isLoading}
                        error={setMaxRTCorrectionResult.isError}
                    />
                </FormControl>

            }
        </Block>
    )
}

/*
 <LabelLarge>{<FormattedMessage id="Devices.SensorRange" defaultMessage="Sensor Range" />}</LabelLarge>
            <SensorRangeConfig rangeMin={rangeMin} rangeMax={rangeMax} dimension={props.dimension}
                onRangeMinChanged={onRangeMinChanged} onRangeMaxChanged={onRangeMaxChanged}
                errorMin={setRangeMinResult.error}
                errorMax={setRangeMaxResult.error}
            ></SensorRangeConfig>
            */

